import { render, staticRenderFns } from "./MXPageTabs.vue?vue&type=template&id=7a0f7ee0&scoped=true"
import script from "./MXPageTabs.vue?vue&type=script&lang=js"
export * from "./MXPageTabs.vue?vue&type=script&lang=js"
import "./MXPageTabs.vue?vue&type=style&index=0&id=7a0f7ee0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0f7ee0",
  null
  
)

export default component.exports